const Hero = () => {
    const hero = document.querySelector("#hero");
    const heroHeight = hero.offsetHeight;

    window.addEventListener("scroll", function() {
        const scrollTop = window.scrollY;
        const opacity = (heroHeight - scrollTop) / heroHeight;

        if (opacity >= 0) {
            hero.style.opacity = opacity;
        } else {
            hero.style.opacity = 0;
        }
    });
};

export default Hero;
